/* eslint-disable no-useless-escape */
import React, { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import {
  Badge,
  Col, FormFeedback, FormGroup, Input, Label, Row,
} from 'reactstrap';
import {
  getPrefList,
} from '../../redux/actions/prefecture';

const FormTable = (props) => {
  const data = props;
  const prefList = useSelector((state) => state.prefecture.prefList, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPrefList());
  }, [dispatch]);

  const onChangeField = (e) => {
    data.onChange(e);
  };

  return (
    <div style={{
      maxWidth: '800px', margin: '0 auto', backgroundColor: 'white', padding: '20px 20px',
    }}
    >
      <FormGroup row>
        <Label lg={4}>
          お名前
          {' '}
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Row form>
            <Col>
              <FormGroup row>
                <Label for="familyName" xs={3}>姓</Label>
                <Col xs={9}>
                  <Input invalid={data?.formError?.familyName !== ''} onChange={onChangeField} name="familyName" value={data?.form?.familyName} />
                  <FormFeedback>{data?.formError?.familyName}</FormFeedback>
                </Col>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup row>
                <Label for="firstName" xs={3}>名</Label>
                <Col xs={9}>
                  <Input invalid={data?.formError?.firstName !== ''} onChange={onChangeField} name="firstName" value={data?.form?.firstName} />
                  <FormFeedback>{data?.formError?.firstName}</FormFeedback>
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label lg={4}>
          お名前（カタカナ）
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Row form>
            <Col>
              <FormGroup row>
                <Label for="familyNameKana" xs={3}>セイ</Label>
                <Col xs={9}>
                  <Input invalid={data?.formError?.familyNameKana !== ''} onChange={onChangeField} name="familyNameKana" value={data?.form?.familyNameKana} />
                  <FormFeedback>{data?.formError?.familyNameKana}</FormFeedback>
                </Col>
                {' '}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup row>
                <Label for="firstNameKana" xs={3}>メイ</Label>
                <Col xs={9}>
                  <Input invalid={data?.formError?.firstNameKana !== ''} onChange={onChangeField} name="firstNameKana" value={data?.form?.firstNameKana} />
                  <FormFeedback>{data?.formError?.firstNameKana}</FormFeedback>
                </Col>
                {' '}
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="phoneNumber" lg={4}>
          電話番号
          {' '}
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Input invalid={data?.formError?.phoneNumber !== ''} onChange={onChangeField} maxLength="15" name="phoneNumber" value={data?.form?.phoneNumber} placeholder="例: 0123456789" />
          <FormFeedback>{data?.formError?.phoneNumber}</FormFeedback>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="zipCode" lg={4}>
          郵便番号
          {' '}
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Input invalid={data?.formError?.zipCode !== ''} onChange={onChangeField} name="zipCode" maxLength="7" value={data?.form?.zipCode} placeholder="例: 1234567" />
          <FormFeedback>{data?.formError?.zipCode}</FormFeedback>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label lg={4}>
          都道府県
          {' '}
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Input invalid={data?.formError?.prefectureId !== ''} onChange={onChangeField} type="select" name="prefectureId" value={data?.form?.prefectureId}>
            <option value="0">未選択</option>
            {
              prefList.map((pref) => (
                <option key={pref.id} value={pref.id.toString()}>{pref.name}</option>
              ))
                  }
          </Input>
          <FormFeedback>{data?.formError?.prefectureId}</FormFeedback>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="address1" lg={4}>
          市区町村
          {' '}
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Input invalid={data?.formError?.address1 !== ''} onChange={onChangeField} name="address1" value={data?.form?.address1} placeholder="市区町村名" />
          <FormFeedback>{data?.formError?.address1}</FormFeedback>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="address2" lg={4}>
          建物名
        </Label>
        <Col lg={8}>
          <Input onChange={onChangeField} name="address2" value={data?.form?.address2} placeholder="建物名、部屋番号など" />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="email" lg={4}>
          メールアドレス
          {' '}
          <Badge color="danger">
            必須
          </Badge>
        </Label>
        <Col lg={8}>
          <Input invalid={data?.formError?.email !== '' || data?.formError?.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)} onChange={onChangeField} type="email" name="email" value={data?.form?.email} />
          <FormFeedback>{data?.formError?.email}</FormFeedback>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="companyName" lg={4}>会社名</Label>
        <Col lg={8}>
          <Input onChange={onChangeField} name="companyName" value={data?.form?.companyName} />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="department" lg={4}>部署名</Label>
        <Col lg={8}>
          <Input onChange={onChangeField} name="department" value={data?.form?.department} />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="companyUrl" lg={4}>会社URL</Label>
        <Col lg={8}>
          <Input onChange={onChangeField} name="companyUrl" value={data?.form?.companyUrl} />
        </Col>
      </FormGroup>
    </div>
  );
};
export default FormTable;
